// API Configuration for Waypoint Control System

// Backend API URL (same as test-page)
export const API_URL = 'https://waypoint-api-y4ztq5ce2a-pd.a.run.app';

// Connection state management
let isConnected = false;
let connectionListeners = [];

export const getConnectionState = () => isConnected;

export const setConnectionState = (connected) => {
  isConnected = connected;
  connectionListeners.forEach(listener => listener(connected));
};

export const onConnectionChange = (listener) => {
  connectionListeners.push(listener);
  return () => {
    connectionListeners = connectionListeners.filter(l => l !== listener);
  };
};

// Test backend connection
export const testConnection = async (token) => {
  try {
    const response = await fetch(`${API_URL}/`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    if (response.ok && data.status === 'ok') {
      setConnectionState(true);
      return { success: true, data };
    } else {
      setConnectionState(false);
      return { success: false, error: 'Unexpected response', data };
    }
  } catch (error) {
    setConnectionState(false);
    return { success: false, error: error.message };
  }
};

// Disconnect (reset state)
export const disconnect = () => {
  setConnectionState(false);
};
